const defaultState = {
    isPunchoutSession: false,
    checkoutPageUrl: null,
};
export const app = (state = defaultState, action) => {
    switch (action) {
        default:
            return state;
    }
};
